import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { CategoryFileFragmentDoc } from '../../fragment/generated/CategoryFile';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MergeFileMutationVariables = Types.Exact<{
  data: Types.MergeFileInput;
}>;


export type MergeFileMutation = { mergeFile?: { destinationFile?: { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null } | null, oldParent?: { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null } | null } | null };


export const MergeFileDocument = /*#__PURE__*/ gql`
    mutation mergeFile($data: MergeFileInput!) {
  mergeFile(data: $data) {
    destinationFile {
      ...CategoryFile
    }
    oldParent {
      ...CategoryFile
    }
  }
}
    ${CategoryFileFragmentDoc}`;

export function useMergeFileMutation() {
  return Urql.useMutation<MergeFileMutation, MergeFileMutationVariables>(MergeFileDocument);
};